interface Props {
  className?: string
}

function PlusIcon({ className }: Props) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 13.5V21H13.5V13.5H21V10.5H13.5V3H10.5V10.5H3V13.5H10.5Z"
        fill="currentColor"
        fillOpacity="0.9"
      />
    </svg>
  )
}

export default PlusIcon
